// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__1XaTS","load2":"spinner_load2__iJe9_","pink":"spinner_pink__15KRH","yellow":"spinner_yellow__1FJeR"};